// extracted by mini-css-extract-plugin
export default {"button":"SortMenu_button__dF03G","label":"SortMenu_label__Z8TiM"};